import Accordion from "react-bootstrap/Accordion";
import faqs from "../../assets/faqs.json";

const styles = {
  wrapper: {
    backgroundColor: "var(--color-background-2)",
    padding: "2rem",
    margin: "0 auto",
    maxWidth: "800px",
    color: "var(--color-text)",
  },
  acordeon: {
    width: "100%",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
  },
  itemAcordeon: {
    backgroundColor: "var(--color-background-2)",
  },
};

function PreguntasFrecuentes() {
  const renderRespuesta = (texto) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const partes = texto.split(urlRegex);

    return partes.map((parte, index) => {
      if (parte.match(urlRegex)) {
        return (
          <a
            key={index}
            href={parte}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "var(--color-primary)", textDecoration: "underline" }}
          >
            enlace
          </a>
        );
      }
      return parte;
    });
  };

  const items = [];

  for (let i = 0; i < faqs.length; i++) {
    items.push(
      <Accordion.Item
        eventKey={String(i)}
        key={faqs[i].id}
        style={styles.itemAcordeon}
        className="border border-2 border-dark w-100"
      >
        <Accordion.Header className="pregunta-header fs-6 fw-semibold">
          {faqs[i].pregunta}
        </Accordion.Header>
        <Accordion.Body className="fs-6">
          {renderRespuesta(faqs[i].respuesta)}
        </Accordion.Body>
      </Accordion.Item>
    );
  }

  return (
    <>
      <div className="d-none d-md-block rounded-5" style={styles.wrapper}>
        <h2 className="fs-1 fw-bold mb-3">Preguntas Frecuentes</h2>
        <Accordion alwaysOpen style={styles.acordeon} className="gap-2">
          {items}
        </Accordion>
        <p
          style={{
            marginTop: "1.5rem",
            fontSize: "clamp(0.5rem, 1.5rem, 2vh)",
            lineHeight: 1.6,
          }}
        >
          ¡Puedes revisar otras consultas en nuestro {" "}
          <a
            href="https://ingenieria.uchile.cl/escuela/docencia/area-de-administracion-docente/presentacion"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "var(--color-primary)", textDecoration: "underline" }}
          >
            sitio web
          </a>
          !
        </p>
      </div>

      <div className="d-block d-md-none rounded-top-5" style={styles.wrapper}>
        <h2 className="fs-1 fw-bold mb-3">Preguntas Frecuentes</h2>
        <Accordion alwaysOpen style={styles.acordeon} className="gap-2">
          {items}
        </Accordion>
        <p
          style={{
            marginTop: "1.5rem",
            fontSize: "clamp(0.5rem, 1.5rem, 2vh)",
            lineHeight: 1.6,
          }}
        >
          ¡Puedes revisar otras consultas en nuestro sitio web:{" "}
          <a
            href="https://ingenieria.uchile.cl/escuela/docencia/area-de-administracion-docente/presentacion"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "var(--color-primary)", textDecoration: "underline" }}
          >
            LINK
          </a>
          !
        </p>
      </div>
    </>
  );
}

export default PreguntasFrecuentes;
